import type { MessagingCreateChatRoomBodyRoomInfoType } from './messagingCreateChatRoomBodyRoomInfoType';

/**
 * 채팅방 정보
 */
export type MessagingCreateChatRoomBodyRoomInfo = {
  name?: string;
  type?: MessagingCreateChatRoomBodyRoomInfoType;
};
